import { LineOASettingResponse } from 'lib/worker/api/get_line_oa_settings_by_prefix';
import React, { useEffect, useState } from 'react';

interface LineOASelectorModalProps {
  isOpen: boolean;
  settings: LineOASettingResponse[];
  onClose: () => void;
  title?: React.ReactNode;
}

function LineOASelectorModal(props: LineOASelectorModalProps) {
  const { isOpen, settings, onClose, title = 'ช่องทางติดต่อ LINE OA' } = props;
  const [isRendered, setIsRendered] = useState(isOpen);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsRendered(true);
      const timer = setTimeout(() => setIsVisible(true), 10);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
      const timer = setTimeout(() => setIsRendered(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isRendered) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        className="shadow-lg"
        style={{
          width: '100%',
          maxWidth: '400px',
          backgroundColor: '#fff',
          borderRadius: '16px',
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '80vh',
          overflow: 'hidden',
          position: 'relative',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'scale(1) translateY(0)' : 'scale(0.95) translateY(20px)',
          transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <button
          type="button"
          aria-label="Close"
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            width: '30px',
            height: '30px',
            background: '#f1f1f1',
            border: 'none',
            borderRadius: '50%',
            fontSize: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: '#666',
            zIndex: 10,
          }}
          onClick={onClose}
        >
          &times;
        </button>

        <div
          style={{
            padding: '24px 24px 16px',
            backgroundColor: '#f8f9fa',
            borderBottom: '1px solid #eaeaea',
          }}
        >
          <h3 style={{ margin: 0, fontSize: '20px', color: '#333', fontWeight: 'bold' }}>
            {title}
          </h3>
          <p style={{ margin: '5px 0 0', fontSize: '14px', color: '#666' }}>
            เลือกช่องทางที่ต้องการติดต่อเจ้าหน้าที่ได้จากรายการด้านล่าง
          </p>
        </div>

        <div
          style={{
            padding: '20px 24px',
            overflowY: 'auto',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {settings.map((setting, index) => (
            <a
              key={`line-oa-selector-${index}`}
              href={setting.url}
              style={{
                display: 'block',
                width: '100%',
                padding: '14px',
                borderRadius: '12px',
                fontWeight: 'bold',
                fontSize: '16px',
                textAlign: 'center',
                backgroundColor: '#00B900', // LINE Green
                color: '#fff',
                textDecoration: 'none',
                marginBottom: index !== settings.length - 1 ? '12px' : '0',
                boxShadow: '0 4px 6px rgba(0, 185, 0, 0.2)',
              }}
            >
              {(setting.name ?? '').trim() || `LINE OA ${index + 1}`}
            </a>
          ))}
        </div>

        <div
          style={{
            padding: '16px 24px',
            borderTop: '1px solid #eaeaea',
            backgroundColor: '#fff',
          }}
        >
          <button
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '12px',
              fontWeight: 'bold',
              fontSize: '16px',
              backgroundColor: '#333',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
            }}
            onClick={onClose}
          >
            ปิด
          </button>
        </div>
      </div>
    </div>
  );
}

export default LineOASelectorModal;
